function AddResources() {
  return (
    <div className="m-0 p-4 w-full xl:w-4xl h-full rounded-xl bg-blue px-8">
      <h1 className="text-orange !text-3xl mb-4">Additional Resources</h1>
    </div>
  );
}

export default AddResources;
